import axios from "axios";
import { API_URL } from "../utils/constant";
import {
  SOCIAL_MEDIA_DATA_FETCHED,
  SOCIAL_MEDIA_DATA_FETCHED_TOTAL,
  SOCIAL_MEDIA_DATA_LOADING,
  SOCIAL_MEDIA_DATA_ERROR,
  SOCIAL_MEDIA_DATA_STATISTICS,
  SOCIAL_MEDIA_DATA_PAGINATION
} from "./index";
import { toastr } from "react-redux-toastr";

// Get all data for an organisation - simplified to only use matchedKeywordsOnly filter
export const fetchSocialMediaData = (orgId, page = 1, limit = 10, matchedKeywordsOnly = '') => (dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  
  dispatch({
    type: SOCIAL_MEDIA_DATA_LOADING,
    payload: true
  });

  let url = `${API_URL}/social-media-data/${orgId}?page=${page}&limit=${limit}`;
  
  if (matchedKeywordsOnly) url += `&matchedKeywordsOnly=${matchedKeywordsOnly}`;
  
  axios
    .get(url)
    .then((response) => {
      const responseData = response.data.data || response.data;
      dispatch({
        type: SOCIAL_MEDIA_DATA_FETCHED,
        payload: responseData.posts || [],
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_FETCHED_TOTAL,
        payload: responseData.total || 0,
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_STATISTICS,
        payload: responseData.statistics || [],
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_PAGINATION,
        payload: {
          page: responseData.page || 1,
          limit: responseData.limit || 10,
          totalPages: responseData.totalPages || 0
        }
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_LOADING,
        payload: false
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage || err.response.data.message;
      }
      
      dispatch({
        type: SOCIAL_MEDIA_DATA_ERROR,
        payload: { error: true, userMessage: message },
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_LOADING,
        payload: false
      });
      
      toastr.error("Error", message);
    });
};

// Get data for a specific user across all platforms
export const fetchSocialMediaDataByUser = (orgId, username, page = 1, limit = 5, startDate = '', endDate = '', filterData = 'all', matchedKeywordsOnly = '') => (dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  
  dispatch({
    type: SOCIAL_MEDIA_DATA_LOADING,
    payload: true
  });

  let url = `${API_URL}/social-media-data/${orgId}/${username}?page=${page}&limit=${limit}`;
  
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  if (filterData && filterData !== 'all') url += `&filter=${filterData}`;
  if (matchedKeywordsOnly) url += `&matchedKeywordsOnly=${matchedKeywordsOnly}`;
  
  axios
    .get(url)
    .then((response) => {
      const responseData = response.data.data || response.data;
      dispatch({
        type: SOCIAL_MEDIA_DATA_FETCHED,
        payload: responseData.posts || [],
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_FETCHED_TOTAL,
        payload: responseData.total || 0,
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_STATISTICS,
        payload: responseData.statistics || [],
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_PAGINATION,
        payload: {
          page: responseData.page || 1,
          limit: responseData.limit || 10,
          totalPages: responseData.totalPages || 0
        }
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_LOADING,
        payload: false
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage || err.response.data.message;
      }
      
      dispatch({
        type: SOCIAL_MEDIA_DATA_ERROR,
        payload: { error: true, userMessage: message },
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_LOADING,
        payload: false
      });
      
      toastr.error("Error", message);
    });
};

// Get data for a specific user on a specific platform
export const fetchSocialMediaDataByUserAndPlatform = (orgId, username, platform, page = 1, limit = 5, startDate = '', endDate = '', filterData = 'all', matchedKeywordsOnly = '') => (dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  
  dispatch({
    type: SOCIAL_MEDIA_DATA_LOADING,
    payload: true
  });

  let url = `${API_URL}/social-media-data/${orgId}/${username}/${platform}?page=${page}&limit=${limit}`;
  
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  if (filterData && filterData !== 'all') url += `&filter=${filterData}`;
  if (matchedKeywordsOnly) url += `&matchedKeywordsOnly=${matchedKeywordsOnly}`;
  
  axios
    .get(url)
    .then((response) => {
      const responseData = response.data.data || response.data;
      dispatch({
        type: SOCIAL_MEDIA_DATA_FETCHED,
        payload: responseData.posts || [],
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_FETCHED_TOTAL,
        payload: responseData.total || 0,
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_STATISTICS,
        payload: responseData.statistics || [],
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_PAGINATION,
        payload: {
          page: responseData.page || 1,
          limit: responseData.limit || 10,
          totalPages: responseData.totalPages || 0
        }
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_LOADING,
        payload: false
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage || err.response.data.message;
      }
      
      dispatch({
        type: SOCIAL_MEDIA_DATA_ERROR,
        payload: { error: true, userMessage: message },
      });
      dispatch({
        type: SOCIAL_MEDIA_DATA_LOADING,
        payload: false
      });
      
      toastr.error("Error", message);
    });
};
